<template>
    <div class="comments-section">
        <div class="comments-header">
            <v-list-item v-if="post.user" :to="`/${post.user.username}/`">
                <v-list-item-avatar color="blue white--text">
                    <img v-if="post.user.avatar_url" :src="post.user.avatar_url" :alt="post.user.name">
                    <span v-else>{{post.user.name[0]}}</span>
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title v-html="post.user.name"></v-list-item-title>
                    <v-list-item-subtitle v-html="post.user.role"></v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </div>
        <v-divider></v-divider>
        <div class="comments-display">
            <div class="comments-content" ref="scrollableArea">
                <div>
                    <v-list class="chat-item" dense>
                        <v-skeleton-loader v-if="fetchingMessages" style="width: 100%" type="list-item-avatar-two-line@4"></v-skeleton-loader>
                        <template v-if="isLogedIn">
                            <template v-for="chatMsg in messages">
                                <v-list-item :key="chatMsg._id">
                                    <!-- <v-list-item-avatar>
                                        <v-avatar color="#30BFC9" size="35">
                                            <img v-if="chatMsg.user.avatar_url" :src="chatMsg.user.avatar_url">
                                            <span v-else class="white--text">{{ chatMsg.user.name[0] }}</span>
                                        </v-avatar>
                                    </v-list-item-avatar> -->
                                    <v-list-item-content>
                                        <v-list-item-title v-html="chatMsg.user.name" class="body-2"></v-list-item-title>
                                        <v-list-item-subtitle v-html="chatMsg.text" class="body-2 chat-item__comment"></v-list-item-subtitle>
                                        <v-list-item-subtitle class="mt-1">
                                            <Timeago :datetime="chatMsg.createdAt" :auto-update="60"></Timeago>
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-progress-circular v-if="!chatMsg.sentAt" indeterminate color="grey" size="10" width="1"></v-progress-circular>
                                    </v-list-item-action>
                                </v-list-item>
                            </template>
                        </template>
                        <template v-else>
                            <v-list-item>
                                Login to start commenting.
                            </v-list-item>
                            <v-list-item to="/account/login/">
                                Click here to login
                            </v-list-item>
                        </template>
                    </v-list>
                </div>
            </div>
        </div>
        <v-divider></v-divider>
        <div class="post-actions" v-if="postActionBar">
            <v-container fluid>
                <bar-post-actions :post="post" likesLink="likes/" :comments="false"></bar-post-actions>
            </v-container>
        </div>
        <v-divider v-if="isLogedIn"></v-divider>
        <div class="comments-action pa-2" v-if="isLogedIn">
            <v-text-field v-model="newMessageText" @keypress.enter="onSend" @click:append="onSend" label="Comment" solo append-icon="mdi-send" flat color="grey" hide-details></v-text-field>
        </div>
    </div>
</template>
<style scoped>
.chat-item .v-list-item__avatar {
    align-self: flex-start;
}

.chat-item__comment {
    height: auto;
    white-space: normal;
}
</style>
<script>
import barPostActions from "@/components/bars/bar-post-actions.vue"
import { CommetService } from "@/base/api/api.service"
import { CometChat } from "@cometchat-pro/chat";
import cometChatConfig from '../../base/api/comet.config';
import ApiService from "@/base/api/api.service"
import {
    CREATE_COMMENT
} from "@/base/api/config";

let messagesRequest;
let listenerID = "D" + new Date().getTime();

export default {
    components: {
        'bar-post-actions': barPostActions
    },
    props: {
        post: Object,
        postActionBar: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            newMessageText: "",
            messages: [],
            isLoadingEarlierMessages: false,
            fetchingMessages: false,
            scrollToBottomTimer: null,
            showLoadEarlier: true
        }
    },
    mounted() {
        // when a new user is created
        // CommetService.createUser({
        //     uid: this.user.firebase_id,
        //     name: this.user.name
        // });

        // when user logins
        // CommetService.loginUser({
        //     uid: this.user.firebase_id
        // });

        // logout
        // CommetService.logOut()
        this.$nextTick(() => {
            this.init()
        })

    },

    methods: {

        init() {
            CometChat.getGroup("post" + this.post.id).then(
                group => {
                    if (group.hasJoined) {
                        this.initMessagesRequest()
                        this.fetchPrevious(false)
                        this.listenMessages()
                        this.addingEventListeners()

                    } else {
                        CommetService.joinGroup({
                            id: "post" + this.post.id
                        }).then(() => {
                            this.initMessagesRequest()
                            this.fetchPrevious(false)
                            this.listenMessages()
                            this.addingEventListeners()

                        });
                    }
                }
            );
        },

        initMessagesRequest() {
            messagesRequest = new CometChat.MessagesRequestBuilder()
                .setLimit(cometChatConfig.messageHistoryLimit)
                .setCategory("message")
                .setSearchKeyword(cometChatConfig.textMessageKey)
                .setGUID("post" + this.post.id)
                .build();
        },

        onSend() {
            if (this.newMessageText === '' || !/\S/.test(this.newMessageText)) return

            // send to comet chat
            let receiverID = "post" + this.post.id;
            let messageText = this.newMessageText;
            let tempMessageId = "m" + new Date().getTime();

            this.messages.push({
                _id: tempMessageId,
                text: messageText,
                createdAt: new Date(),
                user: {
                    _id: this.user.firebase_id,
                    uid: this.user.firebase_id,
                    name: this.user.username,
                    avatar_url: this.user.avatar_url
                }
            });

            this.scrollToBottom();
            this.newMessageText = "";

            CommetService.sendMessage({
                receiverID,
                messageText,
                receiverType: "group",
                metaData: {
                    tempMessageId,
                    avatar_url: this.user.avatar_url
                }
            }).then((message) => {

                // send to api
                ApiService.post(CREATE_COMMENT, {
                    comment: messageText,
                    post_id: this.post.id
                }).then(() => {
                    // to save sentAt value
                    let messageIndex = this.getTemperoryMessageIndex(message);
                    let messagesCopy = this.messages;
                    messagesCopy[messageIndex]._id = message.id;
                    messagesCopy[messageIndex].sentAt = message.sentAt
                    this.messages = messagesCopy;
                });

            });
        },

        onReceive(messages = [], isLoadingEarlierMessages) {
            if (isLoadingEarlierMessages) {
                this.messages.unshift(...messages);
            } else {
                this.messages.push(...messages);
            }
        },

        getTemperoryMessageIndex(message) {
            return this.messages.findIndex((o) => {
                if (o._id == message.metadata.tempMessageId)
                    return true;
                else
                    return undefined;
            });
        },

        getMessageIndex(message) {
            return this.messages.findIndex((o) => {
                if (message.messageId && o._id == message.messageId)
                    return true;
                else
                    return undefined;
            });
        },

        listenMessages() {
            CometChat.addMessageListener(
                listenerID,
                new CometChat.MessageListener({
                    onTextMessageReceived: textMessage => {

                        this.onReceive([{
                            _id: textMessage.id,
                            text: CommetService.formatMessageText(textMessage.text),
                            createdAt: new Date(textMessage.sentAt * 1000),
                            sentAt: textMessage.sentAt,
                            user: {
                                _id: textMessage.sender.uid,
                                uid: textMessage.sender.uid,
                                name: textMessage.sender.name,

                            }
                        }]);

                        this.scrollToBottom()

                    }
                })
            );
        },

        fetchPrevious(isLoadingEarlierMessages) {

            this.isLoadingEarlierMessages = isLoadingEarlierMessages ? true : false;

            this.fetchingMessages = true

            messagesRequest.fetchPrevious().then(
                (messages) => {
                    this.fetchingMessages = false

                    if (messages.length < cometChatConfig.messageHistoryLimit) {
                        this.showLoadEarlier = false;
                    }

                    let prevMessages = [];

                    messages.forEach((message) => {

                        prevMessages.push({
                            _id: message.id,
                            text: CommetService.formatMessageText(message.text),
                            createdAt: new Date(message.sentAt * 1000),
                            sentAt: message.sentAt,
                            myReceipt: message.myReceipt,
                            user: {
                                _id: message.sender.uid,
                                uid: message.sender.uid,
                                name: message.sender.name,
                                avatar_url: message.metadata ? message.metadata.avatar_url : ""
                            }
                        });
                    });

                    this.onReceive(prevMessages, isLoadingEarlierMessages);

                    setTimeout(() => {
                        // this.isChatListLoading = false;
                        this.isLoadingEarlierMessages = false;
                    });

                    if (!isLoadingEarlierMessages) {
                        this.scrollToBottom();
                    }
                },
                () => {
                    this.fetchingMessages = false


                    // setTimeout(() => {
                    //     this.isChatListLoading = false;
                    // });
                }
            );
        },

        onScroll(e) {
            const scrollArea = e.target
            const scrollTop = scrollArea.scrollTop

            if (scrollTop <= 100 && !this.fetchingMessages) this.fetchPrevious(true)
        },

        scrollToBottom() {
            const scrollArea = this.$refs.scrollableArea

            if (this.scrollToBottomTimer) clearTimeout(this.scrollToBottomTimer)

            if (scrollArea) {
                this.scrollToBottomTimer = setTimeout(() => {
                    scrollArea.scrollTop = scrollArea.scrollHeight
                })
            }

        },

        addingEventListeners() {
            const scrollArea = this.$refs.scrollableArea
            if (scrollArea) {
                scrollArea.addEventListener('scroll', this.onScroll, false)
            }
        }
    },

    beforeDestroy() {
        const scrollArea = this.$refs.scrollableArea
        scrollArea.removeEventListener('scroll', this.onScroll, false)
    }
}
</script>